export const translations = {
  en: {
    navbar: {
      logo: 'Gursikh Sabha Cancun',
      links: ['Vision', 'Support', 'Partner', 'FAQ'],
      donateCta: 'Donate Now',
    },
    hero: {
      headline1: 'A Gurdwara for Cancun.',
      headline2: 'A Legacy for Generations.',
      subheadline:
        'As Punjabi destination weddings flourish across Mexico, Cancun needs a true spiritual home — a gurdwara to serve families, support sacred ceremonies, welcome travelers, and become a lasting center of sangat, seva, and community.',
      cta1: 'Donate Now',
      cta2: 'Become a Founding Supporter',
      scrollIndicator: 'Discover',
    },
    theNeed: {
      title1: 'The Need Is Real.',
      title2: 'The Moment Is Now.',
      description:
        'While Cancun has become a premier destination for Punjabi weddings and family travel, it lacks the essential spiritual infrastructure. Couples, parents, and grandparents need a trusted place for prayer, Anand Karaj ceremonies, and community support. This is a critical gap we must fill.',
      stats: [
        { number: '250–500', label: 'Punjabi Destination Weddings Annually' },
        { number: 'Zero', label: 'Dedicated Gurdwaras in Cancun Today' },
        { number: 'Global', label: 'Sikh Family Demand Growing Rapidly' },
      ],
    },
    whyCancun: {
      title: 'Why Cancun?',
      description:
        'Cancun is more than just a beautiful location; it is a strategic crossroads. As thousands of Sikh families travel here annually for celebrations and vacations, establishing a gurdwara here ensures that our spiritual roots travel with us, providing a sanctuary of peace and tradition away from home.',
      points: [
        {
          title: 'Premier Destination Hub',
          desc: 'The epicenter of destination weddings in the Americas.',
        },
        {
          title: 'International Accessibility',
          desc: 'Direct flights from major hubs in Canada, USA, and globally.',
        },
        {
          title: 'World-Class Infrastructure',
          desc: 'Unmatched hospitality ecosystem ready to support large events.',
        },
        {
          title: 'Natural Anchor Point',
          desc: 'A strategic location to establish a lasting Sikh spiritual presence.',
        },
        {
          title: 'An Iconic Opportunity',
          desc: 'The chance to build a landmark that blends sacred tradition with tropical elegance.',
        },
      ],
    },
    ourVision: {
      title: 'Our Vision',
      subtitle: 'Building in Phases. Growing with Purpose.',
      phases: [
        {
          num: '01',
          title: 'Establish',
          desc: 'Lease a dedicated unit to immediately begin serving the community with daily prayer, Anand Karaj support, and a welcoming space for travelers.',
        },
        {
          num: '02',
          title: 'Grow',
          desc: 'Build out a beautiful, fully operational gurdwara home, expanding our capacity for hospitality, langar, and larger community gatherings.',
        },
        {
          num: '03',
          title: 'Landmark',
          desc: 'Establish a permanent, best-in-class architectural landmark in Cancun that will stand as a beacon of Sikh heritage for generations.',
        },
      ],
    },
    globalNetwork: {
      title1: 'Supported by a',
      title2: 'Global Network',
      description:
        'This initiative is backed by respected Sikh families, experienced gurdwara builders, hospitality professionals, and destination wedding experts from around the world.',
      noteHighlight: 'Important:',
      note: 'Committed capital is already in place. Community support is needed to bring this vision fully to life and ensure its long-term sustainability.',
      locations: ['Singapore', 'India', 'Canada', 'New York', 'and beyond'],
    },
    weddingEcosystem: {
      eyebrow: 'For the Wedding Ecosystem',
      title: 'A Strategic Partnership Opportunity',
      description:
        'We are calling on destination wedding planners, hospitality professionals, and industry leaders to join us. By partnering with the Cancun Gurdwara, you help ensure your clients have access to a trusted ceremony venue, family hospitality, and the spiritual infrastructure they need for a perfect Anand Karaj.',
      plannerNote:
        'Join leading planners who are already supporting this historic initiative.',
      cta: 'Wedding Planners: Join as a Founding Partner',
    },
    weddingDateInquiry: {
      title: 'Planning Your Destination Wedding?',
      subtitle:
        'Check availability and find out if the Cancun Gurdwara can support your special day.',
      description:
        'Whether you are planning an Anand Karaj in Cancun or exploring destination wedding options, reach out to our team directly. We will help you understand timelines, availability, and how we can support your family.',
      cta: 'Inquire on WhatsApp',
    },
    whatThisMakesPossible: {
      title1: 'What This Makes',
      title2: 'Possible',
      features: [
        {
          title: 'Anand Karaj Support',
          desc: 'A dedicated, sacred space for destination weddings.',
        },
        {
          title: 'Daily Prayer & Sangat',
          desc: 'Consistent spiritual access for locals and travelers alike.',
        },
        {
          title: 'Family Hospitality',
          desc: 'A welcoming environment rooted in the tradition of langar.',
        },
        {
          title: 'Elder & Traveler Welcome',
          desc: 'A sense of home and comfort for visiting families.',
        },
        {
          title: 'Trusted Infrastructure',
          desc: 'Reliable support for complex destination events.',
        },
        {
          title: 'A Landmark for Generations',
          desc: 'Building a legacy of Sikh presence in the Americas.',
        },
      ],
    },
    fundingPathways: {
      title: 'Support the Cancun Gurdwara',
      subtitle:
        'Every contribution brings this historic vision closer to reality. Choose your pathway to support.',
      donateFrom: 'Donate from',
      comingSoon: 'Link Coming Soon',
      opportunities: [
        'Founding Donor Opportunities',
        'Family Sponsorship',
        'Corporate / Hospitality Supporters',
      ],
      inquireCta: 'Inquire Now',
    },
    foundingCircle: {
      title1: 'Join the',
      title2: 'Founding Circle',
      description:
        'This is a once-in-a-generation opportunity to help create a spiritual home that will serve families for decades to come. Your name. Your family. Part of history.',
      cta: 'Become a Founding Supporter',
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        {
          q: 'Why Cancun?',
          a: 'Cancun is the epicenter of destination weddings in the Americas. With hundreds of Punjabi weddings happening annually, it is the most strategic location to establish a spiritual home that serves traveling families, couples, and the local ecosystem.',
        },
        {
          q: 'Why now?',
          a: 'The volume of destination weddings and Sikh travelers to the region has reached a tipping point. Without dedicated spiritual infrastructure, families struggle to conduct Anand Karaj ceremonies with the proper reverence and support they deserve.',
        },
        {
          q: 'Is there already committed capital?',
          a: 'Yes. This initiative is backed by experienced community builders and families who have already committed initial capital. However, broader community support is essential to secure the lease, complete the build-out, and ensure long-term sustainability.',
        },
        {
          q: 'What does Phase One fund?',
          a: 'Phase One funds the securing of a leased space, operational setup, and readiness to support daily prayer, Anand Karaj ceremonies, and basic family hospitality.',
        },
        {
          q: 'How can wedding planners help?',
          a: 'Wedding planners can join as Founding Partners, integrating the gurdwara into their service offerings, directing client support, and helping us build a seamless experience for couples.',
        },
        {
          q: 'Can families contribute from different countries?',
          a: 'Yes. We are setting up dedicated funding pathways for supporters in Canada, the USA, Mexico, and internationally to ensure seamless and compliant contributions.',
        },
      ],
    },
    finalCta: {
      headline1: 'Help Build a Spiritual Home That Will',
      headline2: 'Endure for Generations',
      cta1: 'Donate Now',
      cta2: 'Become a Founding Supporter',
      cta3: 'Partner With Us',
      copyright: '© 2026 Gursikh Sabha Cancun. All rights reserved.',
      contact: 'Contact',
      inquiries: 'Inquiries',
      privacy: 'Privacy',
    },
    stickyMobileCta: {
      text: 'Donate Now',
    },
  },
  pa: {
    navbar: {
      logo: 'ਗੁਰਸਿੱਖ ਸਭਾ ਕੈਨਕੁਨ',
      links: ['ਦ੍ਰਿਸ਼ਟੀਕੋਣ', 'ਸਮਰਥਨ', 'ਭਾਈਵਾਲ', 'ਸਵਾਲ'],
      donateCta: 'ਹੁਣੇ ਦਾਨ ਕਰੋ',
    },
    hero: {
      headline1: 'ਕੈਨਕੁਨ ਲਈ ਇੱਕ ਗੁਰਦੁਆਰਾ।',
      headline2: 'ਪੀੜ੍ਹੀਆਂ ਲਈ ਇੱਕ ਵਿਰਾਸਤ।',
      subheadline:
        'ਜਿਵੇਂ-ਜਿਵੇਂ ਮੈਕਸੀਕੋ ਵਿੱਚ ਪੰਜਾਬੀ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ ਵਧ ਰਹੇ ਹਨ, ਕੈਨਕੁਨ ਨੂੰ ਇੱਕ ਸੱਚੇ ਅਧਿਆਤਮਿਕ ਘਰ ਦੀ ਲੋੜ ਹੈ — ਇੱਕ ਗੁਰਦੁਆਰਾ ਜੋ ਪਰਿਵਾਰਾਂ ਦੀ ਸੇਵਾ ਕਰੇ, ਪਵਿੱਤਰ ਰਸਮਾਂ ਦਾ ਸਮਰਥਨ ਕਰੇ, ਯਾਤਰੀਆਂ ਦਾ ਸਵਾਗਤ ਕਰੇ, ਅਤੇ ਸੰਗਤ, ਸੇਵਾ ਅਤੇ ਭਾਈਚਾਰੇ ਦਾ ਸਥਾਈ ਕੇਂਦਰ ਬਣੇ।',
      cta1: 'ਹੁਣੇ ਦਾਨ ਕਰੋ',
      cta2: 'ਸੰਸਥਾਪਕ ਸਮਰਥਕ ਬਣੋ',
      scrollIndicator: 'ਖੋਜੋ',
    },
    theNeed: {
      title1: 'ਲੋੜ ਅਸਲੀ ਹੈ।',
      title2: 'ਸਮਾਂ ਹੁਣ ਹੈ।',
      description:
        'ਜਦੋਂ ਕਿ ਕੈਨਕੁਨ ਪੰਜਾਬੀ ਵਿਆਹਾਂ ਅਤੇ ਪਰਿਵਾਰਕ ਯਾਤਰਾ ਲਈ ਪ੍ਰਮੁੱਖ ਮੰਜ਼ਿਲ ਬਣ ਗਿਆ ਹੈ, ਇਸ ਵਿੱਚ ਜ਼ਰੂਰੀ ਅਧਿਆਤਮਿਕ ਢਾਂਚੇ ਦੀ ਘਾਟ ਹੈ। ਜੋੜਿਆਂ, ਮਾਪਿਆਂ ਅਤੇ ਦਾਦਾ-ਦਾਦੀਆਂ ਨੂੰ ਪ੍ਰਾਰਥਨਾ, ਆਨੰਦ ਕਾਰਜ ਅਤੇ ਭਾਈਚਾਰਕ ਸਹਾਇਤਾ ਲਈ ਇੱਕ ਭਰੋਸੇਯੋਗ ਥਾਂ ਦੀ ਲੋੜ ਹੈ।',
      stats: [
        { number: '250–500', label: 'ਸਾਲਾਨਾ ਪੰਜਾਬੀ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ' },
        { number: 'ਜ਼ੀਰੋ', label: 'ਕੈਨਕੁਨ ਵਿੱਚ ਸਮਰਪਿਤ ਗੁਰਦੁਆਰੇ' },
        { number: 'ਵਿਸ਼ਵ', label: 'ਸਿੱਖ ਪਰਿਵਾਰਾਂ ਦੀ ਮੰਗ ਵਧ ਰਹੀ ਹੈ' },
      ],
    },
    whyCancun: {
      title: 'ਕੈਨਕੁਨ ਕਿਉਂ?',
      description:
        'ਕੈਨਕੁਨ ਸਿਰਫ਼ ਇੱਕ ਸੁੰਦਰ ਥਾਂ ਨਹੀਂ ਹੈ; ਇਹ ਇੱਕ ਰਣਨੀਤਕ ਚੌਰਾਹਾ ਹੈ। ਜਿਵੇਂ ਹਜ਼ਾਰਾਂ ਸਿੱਖ ਪਰਿਵਾਰ ਹਰ ਸਾਲ ਜਸ਼ਨਾਂ ਅਤੇ ਛੁੱਟੀਆਂ ਲਈ ਇੱਥੇ ਆਉਂਦੇ ਹਨ, ਇੱਥੇ ਗੁਰਦੁਆਰਾ ਸਥਾਪਿਤ ਕਰਨਾ ਯਕੀਨੀ ਬਣਾਉਂਦਾ ਹੈ ਕਿ ਸਾਡੀਆਂ ਅਧਿਆਤਮਿਕ ਜੜ੍ਹਾਂ ਸਾਡੇ ਨਾਲ ਸਫ਼ਰ ਕਰਨ।',
      points: [
        {
          title: 'ਪ੍ਰਮੁੱਖ ਡੈਸਟੀਨੇਸ਼ਨ ਹੱਬ',
          desc: 'ਅਮਰੀਕਾ ਵਿੱਚ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹਾਂ ਦਾ ਕੇਂਦਰ।',
        },
        {
          title: 'ਅੰਤਰਰਾਸ਼ਟਰੀ ਪਹੁੰਚ',
          desc: 'ਕੈਨੇਡਾ, ਅਮਰੀਕਾ ਅਤੇ ਵਿਸ਼ਵ ਭਰ ਤੋਂ ਸਿੱਧੀਆਂ ਉਡਾਣਾਂ।',
        },
        {
          title: 'ਵਿਸ਼ਵ-ਪੱਧਰੀ ਬੁਨਿਆਦੀ ਢਾਂਚਾ',
          desc: 'ਵੱਡੇ ਸਮਾਗਮਾਂ ਦਾ ਸਮਰਥਨ ਕਰਨ ਲਈ ਬੇਮਿਸਾਲ ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਵਾਤਾਵਰਣ।',
        },
        {
          title: 'ਕੁਦਰਤੀ ਐਂਕਰ ਪੁਆਇੰਟ',
          desc: 'ਸਿੱਖ ਅਧਿਆਤਮਿਕ ਮੌਜੂਦਗੀ ਸਥਾਪਿਤ ਕਰਨ ਲਈ ਰਣਨੀਤਕ ਸਥਾਨ।',
        },
        {
          title: 'ਇੱਕ ਇਤਿਹਾਸਕ ਮੌਕਾ',
          desc: 'ਪਵਿੱਤਰ ਪਰੰਪਰਾ ਅਤੇ ਖੰਡੀ ਸ਼ਾਨ ਨੂੰ ਜੋੜਨ ਵਾਲਾ ਨਿਸ਼ਾਨ ਬਣਾਉਣ ਦਾ ਮੌਕਾ।',
        },
      ],
    },
    ourVision: {
      title: 'ਸਾਡਾ ਦ੍ਰਿਸ਼ਟੀਕੋਣ',
      subtitle: 'ਪੜਾਵਾਂ ਵਿੱਚ ਉਸਾਰੀ। ਮਕਸਦ ਨਾਲ ਵਿਕਾਸ।',
      phases: [
        {
          num: '01',
          title: 'ਸਥਾਪਨਾ',
          desc: 'ਰੋਜ਼ਾਨਾ ਪ੍ਰਾਰਥਨਾ, ਆਨੰਦ ਕਾਰਜ ਸਹਾਇਤਾ, ਅਤੇ ਯਾਤਰੀਆਂ ਲਈ ਸਵਾਗਤੀ ਥਾਂ ਨਾਲ ਭਾਈਚਾਰੇ ਦੀ ਸੇਵਾ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਇੱਕ ਸਮਰਪਿਤ ਯੂਨਿਟ ਲੀਜ਼ ਤੇ ਲਓ।',
        },
        {
          num: '02',
          title: 'ਵਿਕਾਸ',
          desc: 'ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ, ਲੰਗਰ ਅਤੇ ਵੱਡੇ ਭਾਈਚਾਰਕ ਇਕੱਠਾਂ ਲਈ ਸਮਰੱਥਾ ਵਧਾਉਂਦੇ ਹੋਏ ਇੱਕ ਸੁੰਦਰ, ਪੂਰੀ ਤਰ੍ਹਾਂ ਕਾਰਜਸ਼ੀਲ ਗੁਰਦੁਆਰਾ ਘਰ ਬਣਾਓ।',
        },
        {
          num: '03',
          title: 'ਨਿਸ਼ਾਨ',
          desc: 'ਕੈਨਕੁਨ ਵਿੱਚ ਇੱਕ ਸਥਾਈ, ਸਰਵੋਤਮ ਆਰਕੀਟੈਕਚਰਲ ਨਿਸ਼ਾਨ ਸਥਾਪਿਤ ਕਰੋ ਜੋ ਪੀੜ੍ਹੀਆਂ ਲਈ ਸਿੱਖ ਵਿਰਾਸਤ ਦੀ ਰੌਸ਼ਨੀ ਬਣੇ।',
        },
      ],
    },
    globalNetwork: {
      title1: 'ਇੱਕ',
      title2: 'ਵਿਸ਼ਵ ਨੈੱਟਵਰਕ ਦੁਆਰਾ ਸਮਰਥਿਤ',
      description:
        'ਇਹ ਪਹਿਲਕਦਮੀ ਸਤਿਕਾਰਤ ਸਿੱਖ ਪਰਿਵਾਰਾਂ, ਤਜਰਬੇਕਾਰ ਗੁਰਦੁਆਰਾ ਨਿਰਮਾਤਾਵਾਂ, ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਪੇਸ਼ੇਵਰਾਂ ਅਤੇ ਦੁਨੀਆ ਭਰ ਦੇ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ ਮਾਹਿਰਾਂ ਦੁਆਰਾ ਸਮਰਥਿਤ ਹੈ।',
      noteHighlight: 'ਮਹੱਤਵਪੂਰਨ:',
      note: 'ਪ੍ਰਤੀਬੱਧ ਪੂੰਜੀ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ। ਇਸ ਦ੍ਰਿਸ਼ਟੀਕੋਣ ਨੂੰ ਪੂਰੀ ਤਰ੍ਹਾਂ ਸਾਕਾਰ ਕਰਨ ਲਈ ਭਾਈਚਾਰਕ ਸਹਾਇਤਾ ਦੀ ਲੋੜ ਹੈ।',
      locations: ['ਸਿੰਗਾਪੁਰ', 'ਭਾਰਤ', 'ਕੈਨੇਡਾ', 'ਨਿਊਯਾਰਕ', 'ਅਤੇ ਹੋਰ'],
    },
    weddingEcosystem: {
      eyebrow: 'ਵਿਆਹ ਈਕੋਸਿਸਟਮ ਲਈ',
      title: 'ਇੱਕ ਰਣਨੀਤਕ ਭਾਈਵਾਲੀ ਦਾ ਮੌਕਾ',
      description:
        'ਅਸੀਂ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ ਯੋਜਨਾਕਾਰਾਂ, ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਪੇਸ਼ੇਵਰਾਂ ਅਤੇ ਉਦਯੋਗ ਦੇ ਆਗੂਆਂ ਨੂੰ ਸਾਡੇ ਨਾਲ ਜੁੜਨ ਦਾ ਸੱਦਾ ਦਿੰਦੇ ਹਾਂ। ਕੈਨਕੁਨ ਗੁਰਦੁਆਰੇ ਨਾਲ ਭਾਈਵਾਲੀ ਕਰਕੇ, ਤੁਸੀਂ ਆਪਣੇ ਗਾਹਕਾਂ ਨੂੰ ਇੱਕ ਭਰੋਸੇਯੋਗ ਰਸਮ ਸਥਾਨ, ਪਰਿਵਾਰਕ ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਅਤੇ ਸੰਪੂਰਨ ਆਨੰਦ ਕਾਰਜ ਲਈ ਅਧਿਆਤਮਿਕ ਢਾਂਚਾ ਯਕੀਨੀ ਬਣਾਉਂਦੇ ਹੋ।',
      plannerNote:
        'ਉਨ੍ਹਾਂ ਪ੍ਰਮੁੱਖ ਯੋਜਨਾਕਾਰਾਂ ਨਾਲ ਜੁੜੋ ਜੋ ਪਹਿਲਾਂ ਹੀ ਇਸ ਇਤਿਹਾਸਕ ਪਹਿਲਕਦਮੀ ਦਾ ਸਮਰਥਨ ਕਰ ਰਹੇ ਹਨ।',
      cta: 'ਵਿਆਹ ਯੋਜਨਾਕਾਰ: ਸੰਸਥਾਪਕ ਭਾਈਵਾਲ ਬਣੋ',
    },
    weddingDateInquiry: {
      title: 'ਆਪਣੇ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ ਦੀ ਯੋਜਨਾ ਬਣਾ ਰਹੇ ਹੋ?',
      subtitle:
        'ਉਪਲਬਧਤਾ ਦੀ ਜਾਂਚ ਕਰੋ ਅਤੇ ਪਤਾ ਲਗਾਓ ਕਿ ਕੈਨਕੁਨ ਗੁਰਦੁਆਰਾ ਤੁਹਾਡੇ ਖਾਸ ਦਿਨ ਲਈ ਕਿਵੇਂ ਸਹਾਇਤਾ ਕਰ ਸਕਦਾ ਹੈ।',
      description:
        'ਭਾਵੇਂ ਤੁਸੀਂ ਕੈਨਕੁਨ ਵਿੱਚ ਆਨੰਦ ਕਾਰਜ ਦੀ ਯੋਜਨਾ ਬਣਾ ਰਹੇ ਹੋ ਜਾਂ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹ ਦੇ ਵਿਕਲਪਾਂ ਦੀ ਖੋਜ ਕਰ ਰਹੇ ਹੋ, ਸਾਡੀ ਟੀਮ ਨਾਲ ਸਿੱਧੇ ਸੰਪਰਕ ਕਰੋ। ਅਸੀਂ ਤੁਹਾਨੂੰ ਸਮਾਂ-ਸੀਮਾਵਾਂ, ਉਪਲਬਧਤਾ ਅਤੇ ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਦੀ ਸਹਾਇਤਾ ਬਾਰੇ ਸਮਝਣ ਵਿੱਚ ਮਦਦ ਕਰਾਂਗੇ।',
      cta: 'WhatsApp ਤੇ ਪੁੱਛਗਿੱਛ ਕਰੋ',
    },
    whatThisMakesPossible: {
      title1: 'ਇਹ ਕੀ',
      title2: 'ਸੰਭਵ ਬਣਾਉਂਦਾ ਹੈ',
      features: [
        {
          title: 'ਆਨੰਦ ਕਾਰਜ ਸਹਾਇਤਾ',
          desc: 'ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹਾਂ ਲਈ ਸਮਰਪਿਤ, ਪਵਿੱਤਰ ਥਾਂ।',
        },
        {
          title: 'ਰੋਜ਼ਾਨਾ ਪ੍ਰਾਰਥਨਾ ਅਤੇ ਸੰਗਤ',
          desc: 'ਸਥਾਨਕ ਅਤੇ ਯਾਤਰੀਆਂ ਲਈ ਨਿਰੰਤਰ ਅਧਿਆਤਮਿਕ ਪਹੁੰਚ।',
        },
        {
          title: 'ਪਰਿਵਾਰਕ ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ',
          desc: 'ਲੰਗਰ ਦੀ ਪਰੰਪਰਾ ਵਿੱਚ ਜੜ੍ਹਿਆ ਸਵਾਗਤੀ ਮਾਹੌਲ।',
        },
        {
          title: 'ਬਜ਼ੁਰਗ ਅਤੇ ਯਾਤਰੀ ਸਵਾਗਤ',
          desc: 'ਮਿਲਣ ਆਉਣ ਵਾਲੇ ਪਰਿਵਾਰਾਂ ਲਈ ਘਰ ਅਤੇ ਆਰਾਮ ਦੀ ਭਾਵਨਾ।',
        },
        {
          title: 'ਭਰੋਸੇਯੋਗ ਢਾਂਚਾ',
          desc: 'ਗੁੰਝਲਦਾਰ ਡੈਸਟੀਨੇਸ਼ਨ ਸਮਾਗਮਾਂ ਲਈ ਭਰੋਸੇਯੋਗ ਸਹਾਇਤਾ।',
        },
        {
          title: 'ਪੀੜ੍ਹੀਆਂ ਲਈ ਨਿਸ਼ਾਨ',
          desc: 'ਅਮਰੀਕਾ ਵਿੱਚ ਸਿੱਖ ਮੌਜੂਦਗੀ ਦੀ ਵਿਰਾਸਤ ਬਣਾਉਣਾ।',
        },
      ],
    },
    fundingPathways: {
      title: 'ਕੈਨਕੁਨ ਗੁਰਦੁਆਰੇ ਦਾ ਸਮਰਥਨ ਕਰੋ',
      subtitle:
        'ਹਰ ਯੋਗਦਾਨ ਇਸ ਇਤਿਹਾਸਕ ਦ੍ਰਿਸ਼ਟੀਕੋਣ ਨੂੰ ਹਕੀਕਤ ਦੇ ਨੇੜੇ ਲਿਆਉਂਦਾ ਹੈ।',
      donateFrom: 'ਤੋਂ ਦਾਨ ਕਰੋ',
      comingSoon: 'ਲਿੰਕ ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ',
      opportunities: [
        'ਸੰਸਥਾਪਕ ਦਾਨੀ ਮੌਕੇ',
        'ਪਰਿਵਾਰਕ ਸਪਾਂਸਰਸ਼ਿਪ',
        'ਕਾਰਪੋਰੇਟ / ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਸਮਰਥਕ',
      ],
      inquireCta: 'ਹੁਣੇ ਪੁੱਛਗਿੱਛ ਕਰੋ',
    },
    foundingCircle: {
      title1: 'ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ',
      title2: 'ਸੰਸਥਾਪਕ ਸਰਕਲ',
      description:
        'ਇਹ ਇੱਕ ਪੀੜ੍ਹੀ ਵਿੱਚ ਇੱਕ ਵਾਰ ਮਿਲਣ ਵਾਲਾ ਮੌਕਾ ਹੈ ਇੱਕ ਅਧਿਆਤਮਿਕ ਘਰ ਬਣਾਉਣ ਵਿੱਚ ਮਦਦ ਕਰਨ ਦਾ ਜੋ ਦਹਾਕਿਆਂ ਤੱਕ ਪਰਿਵਾਰਾਂ ਦੀ ਸੇਵਾ ਕਰੇਗਾ। ਤੁਹਾਡਾ ਨਾਮ। ਤੁਹਾਡਾ ਪਰਿਵਾਰ। ਇਤਿਹਾਸ ਦਾ ਹਿੱਸਾ।',
      cta: 'ਸੰਸਥਾਪਕ ਸਮਰਥਕ ਬਣੋ',
    },
    faq: {
      title: 'ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ',
      items: [
        {
          q: 'ਕੈਨਕੁਨ ਕਿਉਂ?',
          a: 'ਕੈਨਕੁਨ ਅਮਰੀਕਾ ਵਿੱਚ ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹਾਂ ਦਾ ਕੇਂਦਰ ਹੈ। ਸੈਂਕੜੇ ਪੰਜਾਬੀ ਵਿਆਹ ਸਾਲਾਨਾ ਹੁੰਦੇ ਹਨ, ਇਹ ਯਾਤਰਾ ਕਰਨ ਵਾਲੇ ਪਰਿਵਾਰਾਂ ਅਤੇ ਜੋੜਿਆਂ ਦੀ ਸੇਵਾ ਕਰਨ ਲਈ ਸਭ ਤੋਂ ਰਣਨੀਤਕ ਸਥਾਨ ਹੈ।',
        },
        {
          q: 'ਹੁਣ ਕਿਉਂ?',
          a: 'ਡੈਸਟੀਨੇਸ਼ਨ ਵਿਆਹਾਂ ਅਤੇ ਸਿੱਖ ਯਾਤਰੀਆਂ ਦੀ ਗਿਣਤੀ ਇੱਕ ਮੋੜ ਤੇ ਪਹੁੰਚ ਗਈ ਹੈ। ਸਮਰਪਿਤ ਅਧਿਆਤਮਿਕ ਢਾਂਚੇ ਤੋਂ ਬਿਨਾਂ, ਪਰਿਵਾਰ ਉਚਿਤ ਸਤਿਕਾਰ ਨਾਲ ਆਨੰਦ ਕਾਰਜ ਕਰਨ ਵਿੱਚ ਮੁਸ਼ਕਲ ਮਹਿਸੂਸ ਕਰਦੇ ਹਨ।',
        },
        {
          q: 'ਕੀ ਪਹਿਲਾਂ ਹੀ ਪ੍ਰਤੀਬੱਧ ਪੂੰਜੀ ਹੈ?',
          a: 'ਹਾਂ। ਇਹ ਪਹਿਲਕਦਮੀ ਤਜਰਬੇਕਾਰ ਭਾਈਚਾਰਕ ਨਿਰਮਾਤਾਵਾਂ ਅਤੇ ਪਰਿਵਾਰਾਂ ਦੁਆਰਾ ਸਮਰਥਿਤ ਹੈ ਜਿਨ੍ਹਾਂ ਨੇ ਸ਼ੁਰੂਆਤੀ ਪੂੰਜੀ ਪ੍ਰਤੀਬੱਧ ਕੀਤੀ ਹੈ। ਹਾਲਾਂਕਿ, ਲੀਜ਼ ਸੁਰੱਖਿਅਤ ਕਰਨ ਅਤੇ ਲੰਬੇ ਸਮੇਂ ਦੀ ਸਥਿਰਤਾ ਯਕੀਨੀ ਬਣਾਉਣ ਲਈ ਵਿਆਪਕ ਭਾਈਚਾਰਕ ਸਹਾਇਤਾ ਜ਼ਰੂਰੀ ਹੈ।',
        },
        {
          q: 'ਪਹਿਲਾ ਪੜਾਅ ਕੀ ਫੰਡ ਕਰਦਾ ਹੈ?',
          a: 'ਪਹਿਲਾ ਪੜਾਅ ਲੀਜ਼ ਤੇ ਥਾਂ ਸੁਰੱਖਿਅਤ ਕਰਨ, ਸੰਚਾਲਨ ਸੈੱਟਅੱਪ, ਅਤੇ ਰੋਜ਼ਾਨਾ ਪ੍ਰਾਰਥਨਾ, ਆਨੰਦ ਕਾਰਜ ਅਤੇ ਬੁਨਿਆਦੀ ਪਰਿਵਾਰਕ ਮਹਿਮਾਨ-ਨਿਵਾਜ਼ੀ ਦਾ ਸਮਰਥਨ ਕਰਨ ਲਈ ਤਿਆਰੀ ਨੂੰ ਫੰਡ ਕਰਦਾ ਹੈ।',
        },
        {
          q: 'ਵਿਆਹ ਯੋਜਨਾਕਾਰ ਕਿਵੇਂ ਮਦਦ ਕਰ ਸਕਦੇ ਹਨ?',
          a: 'ਵਿਆਹ ਯੋਜਨਾਕਾਰ ਸੰਸਥਾਪਕ ਭਾਈਵਾਲ ਵਜੋਂ ਸ਼ਾਮਲ ਹੋ ਸਕਦੇ ਹਨ, ਗੁਰਦੁਆਰੇ ਨੂੰ ਆਪਣੀਆਂ ਸੇਵਾਵਾਂ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰ ਸਕਦੇ ਹਨ ਅਤੇ ਜੋੜਿਆਂ ਲਈ ਸਹਿਜ ਅਨੁਭਵ ਬਣਾਉਣ ਵਿੱਚ ਮਦਦ ਕਰ ਸਕਦੇ ਹਨ।',
        },
        {
          q: 'ਕੀ ਪਰਿਵਾਰ ਵੱਖ-ਵੱਖ ਦੇਸ਼ਾਂ ਤੋਂ ਯੋਗਦਾਨ ਪਾ ਸਕਦੇ ਹਨ?',
          a: 'ਹਾਂ। ਅਸੀਂ ਕੈਨੇਡਾ, ਅਮਰੀਕਾ, ਮੈਕਸੀਕੋ ਅਤੇ ਅੰਤਰਰਾਸ਼ਟਰੀ ਸਮਰਥਕਾਂ ਲਈ ਸਮਰਪਿਤ ਫੰਡਿੰਗ ਮਾਰਗ ਸਥਾਪਿਤ ਕਰ ਰਹੇ ਹਾਂ।',
        },
      ],
    },
    finalCta: {
      headline1: 'ਇੱਕ ਅਧਿਆਤਮਿਕ ਘਰ ਬਣਾਉਣ ਵਿੱਚ ਮਦਦ ਕਰੋ ਜੋ',
      headline2: 'ਪੀੜ੍ਹੀਆਂ ਤੱਕ ਕਾਇਮ ਰਹੇ',
      cta1: 'ਹੁਣੇ ਦਾਨ ਕਰੋ',
      cta2: 'ਸੰਸਥਾਪਕ ਸਮਰਥਕ ਬਣੋ',
      cta3: 'ਸਾਡੇ ਨਾਲ ਭਾਈਵਾਲੀ ਕਰੋ',
      copyright: '© 2026 ਗੁਰਸਿੱਖ ਸਭਾ ਕੈਨਕੁਨ। ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ।',
      contact: 'ਸੰਪਰਕ',
      inquiries: 'ਪੁੱਛਗਿੱਛ',
      privacy: 'ਗੋਪਨੀਯਤਾ',
    },
    stickyMobileCta: {
      text: 'ਹੁਣੇ ਦਾਨ ਕਰੋ',
    },
  },
}
